import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { take } from 'rxjs/internal/operators';
import { mergeMap, tap } from 'rxjs/operators';

import { AuthResponse } from '../models/auth.response';
import { AuthService } from './auth.service';
import * as fromAuth from '../../store';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginResolverService implements Resolve<AuthResponse> {
  constructor(
    private authService: AuthService,
    private router: Router,
    private storeAuth: Store<fromAuth.AuthState>
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<AuthResponse> | Observable<never> {
    const token = route.queryParams.access_token;
    if (token) {
      return this.authService.autoLogin(token).pipe(
        mergeMap(authResponse => {
          if (authResponse.data) {
            return of(authResponse);
          } else {
            this.router.navigate(['/login']);
            return EMPTY;
          }
        })
      );
    } else {
      this.storeAuth.dispatch(fromAuth.logout());
      this.authService.cleanSession();
      return EMPTY;
    }
  }
}
